var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-prod"}},[_c('row-1',{attrs:{"data":_vm.shoeData}}),_c('row-2',{attrs:{"data":_vm.shoesSuggestion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }